<template>
  <div class="product-card-compact">
    <img class="product-image" :src="imgSrc" :alt="productName" />
    <div class="description">
      <p class="brand-name">{{ brandName }}</p>
      <p class="product-name">{{ productName }}</p>
      <Price :price="price" v-if="price" />
      <StarRating v-if="rating" :rating="rating" />
    </div>
  </div>
</template>

<script>
import Price from '@sephora-asia/core-price/Price.vue'
import StarRating from '@sephora-asia/core-star-rating/StarRating.vue'

export default {
  name: 'ProductCard',
  components: {
    Price,
    StarRating
  },
  props: {
    /**
     * Product image URL
     * @type {String}
     */
    imgSrc: {
      type: String,
      required: true
    },
    /**
     * Product name
     * @type {String}
     */
    productName: {
      type: String,
      required: true
    },
    /**
     * Product's brand name
     * @type {String}
     */
    brandName: {
      type: String,
      required: true
    },
    /**
     * Product's price
     * @type {String}
     */
    price: {
      type: String,
      default: ''
    },
    /**
     * Product rating score
     * @type {Number}
     */
    rating: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss" scoped>
.product-card-compact {
  display: flex;
}

.product-image {
  width: 65px;
  height: 65px;
  margin-right: 10px;
}

.description {
  line-height: 17px;

  /deep/ .sell-price {
    font-weight: 400;
  }

  /deep/ .stars {
    font-size: 9px;
  }

  .brand-name {
    font-weight: 500;
  }
}
</style>
